import { Button, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import { useDispatch } from 'react-redux';
import { setOnline } from '../actions/app';
import logo from '../logo.png'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  content: {
    marginTop: '20vh',
    textAlign: 'center'
  },
  logo: {
    width: 400,
    maxWidth: '100%',
    marginBottom: 40
  }
}))

function Offline(props) {
  const classes = useStyles();
  const dispatch = useDispatch();

  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <img
          alt='Logo'
          className={classes.logo}
          src={logo}
        />
        <Typography variant='h2'>App Offline</Typography>
        <Button
          variant='outlined'
          onClick={() => dispatch(setOnline(true))}
        >
          RETRY
        </Button>
      </div>
    </div>
  );
}

export default Offline;
